import { useEffect } from "react";

export const useInputValidation = () => {
  useEffect(() => {
    const observer = new MutationObserver(() => {
      const botContainer = document.getElementById("bot-container");
      if (!botContainer) return;
      botContainer
        .querySelectorAll("input[type='text'], textarea")
        .forEach((input) => {
          if (input.dataset.regexAttached) return;

          input.addEventListener("blur", (e) => {
            const el = e.target;

            el.value = el.value.trim();

            if (el.value !== "" && !/\S/.test(el.value)) {
              el.setCustomValidity(
                "Must contain at least one non-space character",
              );
              el.reportValidity();
            } else {
              el.setCustomValidity("");
            }
          });

          input.dataset.regexAttached = "true";
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);
};
